/* eslint-disable sort-keys */
import { Button, Clickable, H2, IconLockup, P, Section } from '@ahmdigital/ui';
import getOpeningHours from '@ahmdigital/logic/lib/utils/get-opening-hours';
import styled from 'styled-components';

import constants from '../../../../ahm-constants';
import PreLineParagraph from '../../components/pre-line-paragraph';

const ButtonWrapper = styled.div`
  margin-top: 5rem;
`;

const ContactWrapper = styled(IconLockup)`
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  width: 15rem;
`;

const StyledH2 = styled(H2)`
  max-width: 25rem;
`;

const StyledSection = styled(Section)`
  margin-bottom: 3rem;
  padding: 0;
`;

const PET_FAX_NUMBER = '1300 367 229';

const getPetContent = () => ({
  meta: {
    title: 'ahm contact',
    description: `Have questions about ahm insurance policies or quotes? Contact us via phone or email today for help with ahm Pet insurance queries.`,
  },
  banner: {
    preHeading: `Pet Insurance`,
    title: 'Contact us',
  },
  body: (
    <StyledSection>
      <H2 looksLike="h3">Pet insurance general enquiries</H2>
      <P>For help getting a new quote, or any questions on purchasing a policy:</P>
      <ContactWrapper icon={{ name: 'phone-circle' }}>
        <P looksLike="h4">
          <Clickable
            to={`tel:
              ${constants.CONTACT.PHONE.PET_INSURANCE.STANDARD}`}
          >
            {constants.CONTACT.PHONE.PET_INSURANCE.PRETTY}
          </Clickable>
        </P>
        <PreLineParagraph>
          {getOpeningHours(constants.AHM_SERVICE_NAME.PET_INSURANCE)} <br />
          (except public holidays) <br />
          or <br />
          Fax Us: {PET_FAX_NUMBER}
        </PreLineParagraph>
      </ContactWrapper>
      <ContactWrapper icon={{ name: 'device-desktop' }}>
        <P looksLike="h4">Email</P>
        <PreLineParagraph>
          <Clickable to={`mailto:${constants.CONTACT.EMAIL.PET_INSURANCE}`}>
            {constants.CONTACT.EMAIL.PET_INSURANCE}
          </Clickable>{' '}
          <br />
          or <br />
          Write to us: Petinsurance.com.au <br />
          Locked Bag: 9021, Castle Hill, NSW 1765
        </PreLineParagraph>
      </ContactWrapper>
      <ButtonWrapper>
        <StyledH2 looksLike="h3">Have an enquiry about something else?</StyledH2>
        <StyledButton to={constants.URLS.SALES.CONTACT_US}>Contact us</StyledButton>
      </ButtonWrapper>
    </StyledSection>
  ),
});

export default getPetContent;
